import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { authErrorHandleInterceptor } from './app/core/interceptors/auth-error-handle.interceptor';
import { apmHttpInterceptor } from './app/core/interceptors/apm-http.interceptor';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    provideHttpClient(withInterceptors([apmHttpInterceptor, authErrorHandleInterceptor])),
  ],
})
  .catch((err) => console.error(err));
